export default __webpack_public_path__ + "assets/front/scss/affichage-table.29c574ab441b049df47fd862f867ef46.css";